<div class="attribute-boolean-mandatory">

  @if (templateAttribute.labelDictionaryKey) {
    <div class="title" >
      <label [attr.for]="templateAttribute.key">
        <sc-dictionary-label [dictionaryKey]="templateAttribute.labelDictionaryKey"></sc-dictionary-label>
      </label>
    </div>
  }

  <div class="yesno-content-area" [formGroup]="yesNoFormGroup">
    <mat-checkbox  class="yesno-checkbox form-checkbox" formControlName="checkboxYes">
      <sc-dictionary-label dictionaryKey="tmc.document.attribute.boolean-mandatory.option.yes"></sc-dictionary-label>
    </mat-checkbox>
    <mat-checkbox  class="yesno-checkbox form-checkbox" formControlName="checkboxNo">
      <sc-dictionary-label dictionaryKey="tmc.document.attribute.boolean-mandatory.option.no"></sc-dictionary-label>
    </mat-checkbox>
  </div>


</div>
